import React from 'react'
import {ColumnHeaderCell} from "@blueprintjs/table";
import {Menu, MenuItem } from "@blueprintjs/core";



const menuRenderer = (columnIndex, onSortEvent) => {
    return (
        <Menu>
            <MenuItem icon="sort-asc" text="Orden Asc" onClick={() => onSortEvent(columnIndex, "asc")} />
            <MenuItem icon="sort-desc" text="Orden Desc" onClick={() => onSortEvent(columnIndex, "desc")}  />
        </Menu>
    );
}

export const getColumnHeaderCellRenderer= (titulo) => {
    return () =>  <ColumnHeaderCell name={titulo}/>;
}

export const getColumnHeaderCellRendererOrdenable= (titulo, columnIndex, onSortEvent) => {
    return () =>  <ColumnHeaderCell name={titulo} menuRenderer={() => menuRenderer(columnIndex,onSortEvent)}/>;
}
